var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91.698c.194-.56.986-.56 1.18 0l1.618 4.655a.625.625 0 00.578.42l4.927.1c.592.012.837.765.365 1.123L12.65 9.973a.625.625 0 00-.22.68l1.426 4.716c.172.567-.469 1.033-.955.694l-4.045-2.815a.625.625 0 00-.714 0l-4.045 2.815c-.486.339-1.127-.127-.955-.694l1.427-4.717a.625.625 0 00-.22-.679L.421 6.996c-.472-.358-.227-1.11.365-1.123l4.927-.1a.625.625 0 00.578-.42L7.91.698z",
    fill: "#FFD450"
  })));
};

export default SvgStar;